// removed by extract-text-webpack-plugin
module.exports = {"screenshots":"e3Q7"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CaseStudies/MiasanoCaseStudy/styles.scss
// module id = 542
// module chunks = 0